import { useState } from 'react';

const PALETTE = [
  '#e53e3e', '#3b82f6', '#10b981', '#f59e0b',
  '#8b5cf6', '#ec4899', '#06b6d4', '#f97316',
];

function symbolColor(base) {
  let h = 0;
  for (const c of base) h = (h * 31 + c.charCodeAt(0)) & 0xffff;
  return PALETTE[h % PALETTE.length];
}

function CoinIcon({ base, size = 28 }) {
  const [failed, setFailed] = useState(false);
  const bg = symbolColor(base);
  const fontSize = Math.round(size * 0.36);

  if (failed) {
    return (
      <div
        style={{
          width: size, height: size, borderRadius: '50%',
          background: bg, flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize, fontWeight: 700, color: '#fff',
          fontFamily: "'Inter', sans-serif",
          userSelect: 'none',
        }}
      >
        {base.slice(0, 2)}
      </div>
    );
  }

  return (
    <img
      src={`https://assets.coincap.io/assets/icons/${base.toLowerCase()}@2x.png`}
      alt={base}
      width={size}
      height={size}
      style={{ borderRadius: '50%', flexShrink: 0, display: 'block' }}
      onError={() => setFailed(true)}
    />
  );
}

export default CoinIcon;
